import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ReplaySubject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";


@Component({
  selector: "app-cancel-visit",
  templateUrl: "./cancel-visit.component.html",
  styleUrls: ["./cancel-visit.component.scss"],
})
export class CancelVisitComponent implements OnInit, OnDestroy {
  cancelReason: any;
  cancelNote: any;
  cancelReasons: any;
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
  isCancel:boolean=false;
  openCharge:boolean=false;

  constructor(
    public dialogRef: MatDialogRef<CancelVisitComponent>,
    public baseHttpService: AppBaseService,
    private langService: MultiLanguageService,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}


  ngOnInit() {
    this.isCancel=this.data.isCancel?this.data.isCancel:"";
    this.openCharge=this.data.openCharge?this.data.openCharge:""
    let body = {
      reasonTypeMaster: 91,
    };
    let apiurl = OPD_API_URL.REASON_MASTER;
    this.baseHttpService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
    this.baseHttpService
      .postResource(apiurl, body)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.cancelReasons = res;
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  /**
   * On close click
   * @memberof CancelDischargeComponent
   */
  onNoClick(): void {
    this.dialogRef.close();
  }

  /**
   * On save click
   * @memberof CancelDischargeComponent
   */

  SaveRemarks(value) {
    if (this.cancelReason) {
      if(this.isCancel==true){
        let data = {
        isConvertToOP:this.openCharge?this.openCharge:false,
        confirm: value,
        reason: this.cancelReason,
        remark: this.cancelNote,
      };
      this.dialogRef.close(data);
      }else{
        let data = {
          confirm: value,
          reason: this.cancelReason,
          remark: this.cancelNote,
        };
        this.dialogRef.close(data);
      }
     
    } 
    else
    {
      this.snackBar.open(
        this.langService.get("AppointmentListPage.giveReason"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 1000,
        }
      );
    }
  }

}
